const fireConversion = (sendTo) => {
  return new Promise((resolve) => {
    window.gtag('event', 'conversion', { send_to: sendTo, event_callback: resolve });
  });
};

export const fireRegistrationConversion = () => {
  return fireConversion('AW-837006835/JHk1CMq_j3UQ8-uOjwM');
};
